var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-rectangle',{attrs:{"bounds":_vm.square.points,"fillColor":_vm.fillSquareWithColor(_vm.square.color, _vm.square.strength),"weight":0,"fillOpacity":0.5}})}
var staticRenderFns = []

export { render, staticRenderFns }